(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 20484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content027": function() { return /* binding */ Content027; },
  "default": function() { return /* binding */ Content027_Content027; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(39474);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(53128);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/Content027.hook.js








var FETCH_INCREMENT = 4;
var ITEMS_NUMBER = {
    three: 3,
    five: 5
};
var useCollectedEventsRender = function(param) {
    var payload = param.payload;
    var locale = (0,router.useRouter)().locale;
    var ref;
    var itemsAmount = (ref = payload === null || payload === void 0 ? void 0 : payload.itemsAmount) !== null && ref !== void 0 ? ref : "three";
    var eventCategories = payload === null || payload === void 0 ? void 0 : payload.eventCategories;
    var eventCategoriesSlugs = eventCategories === null || eventCategories === void 0 ? void 0 : eventCategories.map(function(param) {
        var slug = param.slug;
        return slug;
    });
    var ref1;
    var eventsType = (ref1 = payload === null || payload === void 0 ? void 0 : payload.eventType) !== null && ref1 !== void 0 ? ref1 : "active";
    var eventsTypeBoolean = Boolean(eventsType === "active");
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("027", payload.id);
    var events = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "events",
            defaultValue: []
        }, 
    ]).events;
    var ref2 = (0,react.useState)(ITEMS_NUMBER[itemsAmount]), limit = ref2[0], setLimit = ref2[1];
    var ref3 = (0,react.useState)(ITEMS_NUMBER[itemsAmount]), fetchStart = ref3[0], setFetchStart = ref3[1];
    var ref4 = (0,react.useState)(events), feed = ref4[0], setFeed = ref4[1];
    (0,react.useEffect)(function() {
        if (feed.length < limit) {
            var collectedDataRender = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var ref, nextEvents, temporaryEvents;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                ;
                                _ctx.next = 3;
                                return (0,cms/* fetchAPI */.I)("/events", {
                                    pagination: {
                                        start: fetchStart,
                                        limit: FETCH_INCREMENT
                                    },
                                    populate: {
                                        previewImage: "*",
                                        eventCategories: {
                                            populate: "*"
                                        }
                                    },
                                    sort: "eventDate",
                                    filters: {
                                        eventCategories: {
                                            slug: {
                                                $in: eventCategoriesSlugs.length > 0 ? eventCategoriesSlugs : null
                                            }
                                        },
                                        active: {
                                            $eq: eventsTypeBoolean
                                        }
                                    }
                                }, locale);
                            case 3:
                                _ctx.t1 = ref = _ctx.sent;
                                _ctx.t0 = _ctx.t1 !== null;
                                if (!_ctx.t0) {
                                    _ctx.next = 7;
                                    break;
                                }
                                _ctx.t0 = ref !== void 0;
                            case 7:
                                if (!_ctx.t0) {
                                    _ctx.next = 11;
                                    break;
                                }
                                _ctx.t2 = ref;
                                _ctx.next = 12;
                                break;
                            case 11:
                                _ctx.t2 = {
                                    data: []
                                };
                            case 12:
                                nextEvents = _ctx.t2;
                                temporaryEvents = nextEvents === null || nextEvents === void 0 ? void 0 : nextEvents.data;
                                setFeed(function(currentFeed) {
                                    return (0,_to_consumable_array/* default */.Z)(currentFeed).concat((0,_to_consumable_array/* default */.Z)(temporaryEvents));
                                });
                                setFetchStart(function(currentFetchStart) {
                                    return currentFetchStart + FETCH_INCREMENT;
                                });
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function collectedDataRender() {
                    return _ref.apply(this, arguments);
                };
            }();
            collectedDataRender();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        limit
    ]);
    var isCompleted = (0,react.useMemo)(function() {
        return feed.length < limit;
    }, [
        feed.length,
        limit
    ]);
    var renderNext = (0,react.useCallback)(function() {
        if (!isCompleted) {
            setLimit(function(limit) {
                return limit + FETCH_INCREMENT;
            });
        }
    }, [
        isCompleted
    ]);
    return {
        feed: feed,
        isCompleted: isCompleted,
        renderNext: renderNext,
        itemsAmount: itemsAmount,
        limit: limit
    };
};

// EXTERNAL MODULE: ./src/components/widgets/content/Content027/Content027.module.scss
var Content027_module = __webpack_require__(25885);
var Content027_module_default = /*#__PURE__*/__webpack_require__.n(Content027_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/widgets/content/Content027/DefaultItem/DefaultItem.module.scss
var DefaultItem_module = __webpack_require__(75320);
var DefaultItem_module_default = /*#__PURE__*/__webpack_require__.n(DefaultItem_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/DefaultItem/DefaultItem.jsx






var DefaultItem = function(param) {
    var item = param.item, itemsAmount = param.itemsAmount;
    var ref, ref1;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((DefaultItem_module_default()).item, (0,_define_property/* default */.Z)({}, (DefaultItem_module_default()).five, itemsAmount === "five")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
            directory: "events",
            slug: item.slug,
            className: (DefaultItem_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: item.previewImage,
                    className: (DefaultItem_module_default()).image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (DefaultItem_module_default()).block,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (DefaultItem_module_default()).date,
                            color: "light",
                            appearance: "bigger",
                            children: item.eventTimeDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (DefaultItem_module_default()).category,
                                    color: "light",
                                    uppercase: true,
                                    children: (ref2 = (ref = item.eventCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref2 !== void 0 ? ref2 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (DefaultItem_module_default()).title,
                                    color: "light",
                                    appearance: "bold",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (DefaultItem_module_default()).details,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                            color: "light",
                                            className: (DefaultItem_module_default()).place,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                    className: (DefaultItem_module_default()).icon,
                                                    name: "message"
                                                }),
                                                t(item.eventType),
                                                ", ",
                                                item.eventPlace
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                            color: "light",
                                            className: (DefaultItem_module_default()).price,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                    className: (DefaultItem_module_default()).icon,
                                                    name: "tag"
                                                }),
                                                item.eventPrice
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/DefaultItem/index.js


// EXTERNAL MODULE: ./src/shared/utils/formatDate/formatTime.js
var formatTime = __webpack_require__(58475);
// EXTERNAL MODULE: ./src/components/widgets/content/Content027/Item/Item.module.scss
var Item_module = __webpack_require__(17638);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/Item/Item.jsx







var Item = function(param) {
    var item = param.item;
    var ref;
    var locale = (0,router.useRouter)().locale;
    var ref1 = (0,react.useMemo)(function() {
        var day = new Date(item.eventDate).getDate();
        var month = new Date(item.eventDate).getMonth() + 1;
        return {
            day: day,
            month: month
        };
    }, [
        item.eventDate
    ]), day = ref1.day, month = ref1.month;
    var t = (0,translations/* useTranslation */.$)().t;
    var formatCounter = function(number) {
        return number > 9 ? number : "0".concat(number);
    };
    var eventStart = (0,react.useMemo)(function() {
        return (0,formatTime/* formatTime */.m)(item.eventDate, locale);
    }, [
        item.eventDate,
        locale
    ]);
    var _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Item_module_default()).item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
            directory: "events",
            slug: item.slug,
            className: (Item_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Item_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Item_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (Item_module_default()).category,
                                uppercase: true,
                                children: (_title = (ref = item.eventCategories) === null || ref === void 0 ? void 0 : ref[0].title) !== null && _title !== void 0 ? _title : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                className: (Item_module_default()).title,
                                color: "dark",
                                appearance: "bold",
                                children: item.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Item_module_default()).bottom,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Item_module_default()).details,
                                children: [
                                    (item === null || item === void 0 ? void 0 : item.eventType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                        color: "dark",
                                        appearance: "bold",
                                        className: (Item_module_default()).type,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (Item_module_default()).icon,
                                                name: "message"
                                            }),
                                            t(item.eventType)
                                        ]
                                    }),
                                    eventStart && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                        color: "dark",
                                        appearance: "bold",
                                        className: (Item_module_default()).time,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (Item_module_default()).icon,
                                                name: "clock"
                                            }),
                                            eventStart
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Item_module_default()).date,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                        className: (Item_module_default()).day,
                                        color: "brand",
                                        appearance: "bold",
                                        plain: true,
                                        children: formatCounter(day)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Paragraph */.nv, {
                                        className: (Item_module_default()).month,
                                        color: "brand",
                                        plain: true,
                                        children: [
                                            "/",
                                            formatCounter(month)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content027/Content027.jsx











var Content027 = function(param) {
    var payload = param.payload;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2 = useCollectedEventsRender({
        payload: payload
    }), feed = ref2.feed, isCompleted = ref2.isCompleted, renderNext = ref2.renderNext, itemsAmount = ref2.itemsAmount;
    var _feed = _toArray(feed), event = _feed[0], rest = _feed.slice(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content027_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content027_module_default()).top,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading2 */.XJ, {
                            className: (Content027_module_default()).title,
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                            value: description,
                            className: (Content027_module_default()).description,
                            color: "dark"
                        })
                    ]
                }),
                feed.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Content027_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Content027_module_default()).list,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultItem, {
                                        item: event,
                                        itemsAmount: itemsAmount
                                    }),
                                    (0,_to_consumable_array/* default */.Z)(rest).map(function(event) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                            item: event
                                        }, event.id);
                                    })
                                ]
                            })
                        }),
                        !isCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                            onClick: renderNext,
                            className: (Content027_module_default()).more,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Content027_module_default()).loader,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Content027_module_default())["loader-wrapper"]),
                                    children: [
                                        t("lazyRendering"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content027_module_default()).icon,
                                            name: "loader"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                    appearance: "bold",
                    children: t("empty_events")
                })
            ]
        })
    });
};
/* harmony default export */ var Content027_Content027 = (Content027);


/***/ }),

/***/ 58475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ formatTime; }
/* harmony export */ });
var formatTime = function(date, locale) {
    if (date) {
        return new Intl.DateTimeFormat(locale, {
            hour: "2-digit",
            minute: "2-digit"
        }).format(new Date(date));
    }
    return null;
};


/***/ }),

/***/ 25885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content027_wrapper__jSKlt","more":"Content027_more__lQcqh","top":"Content027_top__QTPU9","title":"Content027_title__mD_ix","description":"Content027_description__Nsd9C","list":"Content027_list__7SsIr","loader":"Content027_loader___0A8_","loader-wrapper":"Content027_loader-wrapper__HRTO6"};

/***/ }),

/***/ 75320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"DefaultItem_item__Na73Q","five":"DefaultItem_five__DK4Wu","wrapper":"DefaultItem_wrapper__MCqWq","block":"DefaultItem_block__FVqgy","title":"DefaultItem_title__ZBEbz","date":"DefaultItem_date__S1KQR","category":"DefaultItem_category__Y5umM","details":"DefaultItem_details___jpHS","place":"DefaultItem_place__Ekomv","price":"DefaultItem_price__xuWRf","image":"DefaultItem_image___8vbm","icon":"DefaultItem_icon__pehA_"};

/***/ }),

/***/ 17638:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__oyZMP","wrapper":"Item_wrapper__HB02P","bottom":"Item_bottom__aFyIc","block":"Item_block__3aNQn","type":"Item_type__cHc3H","title":"Item_title__gF2Eo","category":"Item_category__O2Dcp","date":"Item_date__8zvC_","day":"Item_day__ZmhR1","month":"Item_month__tfnOJ","icon":"Item_icon__hH4Sj","time":"Item_time__pUGBZ"};

/***/ })

}]);